import {DetailsTabContentWrapper} from '@/features/projects/components/details-tab-content-wrapper/DetailsTabContentWrapper'
import {useTranslation} from '@/translations/i18n'
import {Helmet} from 'react-helmet'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {useOutletContext} from 'react-router-dom'
import {ProjectExtended} from '@/features/projects/types'
import {SocialWelfareConditionsSection} from '@/features/projects/components/social-welfare-conditions-section/SocialWelfareConditionsSection'
import {useState} from 'react'
import {ClinicalPresentationsSection} from '@/features/projects/components/clinical-presentations-section/ClinicalPresentationsSection'
import {ScrollArea} from '@/components/ui/scroll-area/ScrollArea'
import {Scrollbar} from '@/components/ui/scrollbar/Scrollbar'

export type OtherDataCardInEditModeType = 'social_welfare_conditions' | 'clinical_presentations' | null

export const ProjectDetailsOtherData = () => {
    const {project} = useOutletContext<{project: ProjectExtended}>()
    const {t} = useTranslation()
    const [cardInEditMode, setCardInEditMode] = useState<OtherDataCardInEditModeType>(null)

    return (
        <ScrollArea scrollbar={<Scrollbar />}>
            <DetailsTabContentWrapper>
                <Helmet title={t('commons:fullname_details_meta_title', {fullName: project.patient.fullName})} />
                <Flexbox direction="column" gap={4} fullWidth align="stretch">
                    <SocialWelfareConditionsSection
                        cardInEditMode={cardInEditMode}
                        setCardInEditMode={setCardInEditMode}
                    />
                    <ClinicalPresentationsSection
                        cardInEditMode={cardInEditMode}
                        setCardInEditMode={setCardInEditMode}
                    />
                </Flexbox>
            </DetailsTabContentWrapper>
        </ScrollArea>
    )
}
